import { render, staticRenderFns } from "./_nome.vue?vue&type=template&id=02080a41&scoped=true"
import script from "./_nome.vue?vue&type=script&lang=js"
export * from "./_nome.vue?vue&type=script&lang=js"
import style0 from "./_nome.vue?vue&type=style&index=0&id=02080a41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02080a41",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonComponent: require('/home/luiz/Sistemas/loja/components/ButtonComponent.vue').default})
